import React from 'react'

import * as cp from '../../comps'

//@ts-ignore
import styles from './AlarmVerifiedResponsePage.module.css'

export interface AlarmVerifiedResponsePageProps {
  solarCompany: string
}

/**
 * Ticket 12704562114 (Jaron): the Las Vegas alarm verified response
 * requirement has to be explained on the customer proposal itself, not only
 * as a clause inside the contract further down the same document.
 *
 * Wording is Jaron's own, verbatim, and deliberately never says "According
 * to LVMPD Code" - there is no numbered LVMPD code equivalent to a statute.
 * The two authorities it cites (Las Vegas Municipal Code Section 6.18.060,
 * and the LVMPD Verified Response Policy) are the exact ones he specified.
 *
 * Ticket 12898148046, 2026-08-25: he circled the whole page - "What is this?
 * This needs to be official and look decent. No one will look at this" - and
 * clarified an hour later, "It needs to look like an article".
 *
 * So the page was re-laid out and NOT rewritten. Every word below is the same
 * as it was; what changed is that the single 11px paragraph became a title, a
 * lead sentence, and one block per authority. The two sources used to sit
 * mid-sentence inside that paragraph, which is exactly why the page read as
 * something nobody had bothered to format.
 */
export default React.memo<AlarmVerifiedResponsePageProps>(
  function AlarmVerifiedResponsePage({ solarCompany }): React.ReactElement {
    return (
      <cp.PageReport company={solarCompany} companyBorder hPad>
        <div className={styles['page']}>
          <p className={styles['kicker']}>Las Vegas</p>
          <h2 className={styles['title']}>Alarm Verified Response</h2>

          <p className={styles['lead']}>
            Alarm dispatches for properties in Las Vegas are subject to a
            verified response requirement.
          </p>

          <div className={styles['clause']}>
            <p className={styles['clause-source']}>
              Las Vegas Municipal Code Section 6.18.060
            </p>
            <p className={styles['clause-body']}>
              Under Las Vegas Municipal Code Section 6.18.060, the alarm
              monitoring company must attempt to verify an alarm before police
              are notified, and if it cannot verify the alarm by contacting the
              property owner it must dispatch an employee or security guard to
              the property; police are notified only once the alarm has been
              verified as valid or the responder is unable to determine whether
              it is valid.
            </p>
          </div>

          <div className={styles['clause']}>
            <p className={styles['clause-source']}>
              LVMPD Verified Response Policy
            </p>
            <p className={styles['clause-body']}>
              This requirement works together with the LVMPD Verified Response
              Policy, under which the police department does not dispatch
              officers to a burglar alarm that has not been verified.
            </p>
          </div>
        </div>
      </cp.PageReport>
    )
  },
)
